export const ORIGINS = [
  { id: 0, name: 'ORIGIN.all' },
  { id: 1, name: 'ORIGIN.internet' },
  { id: 2, name: 'ORIGIN.local' }
];
